import React, { useState } from 'react';
import AdminSidebar from '../../components/AdminSidebar';

const ApiSettings = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      <AdminSidebar 
        isCollapsed={sidebarCollapsed} 
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} 
      />
      <div 
        className={`transition-all duration-300 ${
          sidebarCollapsed ? 'ml-20' : 'ml-64'
        }`}
      >
        <div className="p-8">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Konfiguracija API Ključeva
            </h1>
            <p className="text-gray-600">
              Upravljajte API ključevima za eksterne servise
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiSettings;